import _toConsumableArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export var applyGraph = function applyGraph(entry, graph) {
  if (entry._graph) {
    var index = graph.findIndex(function (_ref) {
      var type = _ref.type;
      return type === '@else/list+object';
    });

    if (index !== -1) {
      graph.splice.apply(graph, [index + 1, 0].concat(_toConsumableArray(entry._graph.slice(0, -1))));
    }
  }

  entry._graph = graph;
  return entry;
};
export var removeGraph = function removeGraph(entry) {
  delete entry._graph;
  return entry;
};